export const WELCOME_LETTER_CONTAINER_CLASS = "welcome-letter-container";
export const WELCOME_LETTER_LOGO_CLASS = "welcome-letter-logo";
export const WELCOME_LETTER_TOP_RIGHT_CLASS = "welcome-letter-top-right";
export const WELCOME_LETTER_HEADER_CLASS = "welcome-letter-header";
export const WELCOME_LETTER_HEADER_GRID_CLASS = "welcome-letter-header-grid";
export const WELCOME_LETTER_HEADER_COL_CLASS = "welcome-letter-header-col";
export const WELCOME_LETTER_BODY_CLASS = "welcome-letter-body";
export const WELCOME_LETTER_SIGNATURE_CLASS = "welcome-letter-signature";

export const WELCOME_LETTER_BODY_MAX_LENGTH = 1700;
export const WELCOME_LETTER_BODY_MIN_LENGTH = 300;
export const WELCOME_LETTER_BODY_MAX_NO_LOGO_NO_SIGNATURE = 1700;
export const WELCOME_LETTER_BODY_MAX_LOGO_NO_SIGNATURE = 1650;
export const WELCOME_LETTER_BODY_MAX_NO_LOGO_SIGNATURE = 1525;
export const WELCOME_LETTER_BODY_MAX_LOGO_AND_SIGNATURE = 1450;
export const WELCOME_LETTER_OPTIONAL_IMAGE_MAX_KB = 200;
export const WELCOME_LETTER_ADDRESS_MAX_LENGTH = 100;
/** Address column is one third of the letter width (see header grid). */
export const WELCOME_LETTER_ADDRESS_COLUMN_WIDTH_PERCENT = 33.33;

export const WELCOME_LETTER_LOGO_WIDTH = 206;
export const WELCOME_LETTER_LOGO_HEIGHT = 120;
export const WELCOME_LETTER_ADDRESS_WIDTH = 247;
export const WELCOME_LETTER_ADDRESS_HEIGHT = 96;
export const WELCOME_LETTER_SIGNATURE_WIDTH = 250;
export const WELCOME_LETTER_SIGNATURE_HEIGHT = 130;

export const WELCOME_LETTER_IMAGE_SPECS = {
  hotelLogo: [
    {
      name: "Hotel Logo",
      files: 1,
      size: "200 KB",
      height: WELCOME_LETTER_LOGO_HEIGHT,
      width: WELCOME_LETTER_LOGO_WIDTH,
      formats: "JPG, JPEG, PNG",
    },
  ],
  signature: [
    {
      name: "Signature Image",
      files: 1,
      size: "200 KB",
      height: WELCOME_LETTER_SIGNATURE_HEIGHT,
      width: WELCOME_LETTER_SIGNATURE_WIDTH,
      formats: "JPG, JPEG, PNG",
    },
  ],
  address: [
    {
      name: "Address Text Area",
      files: "NA",
      size: "NA",
      height: WELCOME_LETTER_ADDRESS_HEIGHT,
      width: WELCOME_LETTER_ADDRESS_WIDTH,
      formats: "Text",
    },
  ],
};

const escapeHtml = (value = "") =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const formatTopRightText = (text = "") => {
  const trimmed = text.trim();
  if (!trimmed) {
    return "";
  }

  return escapeHtml(trimmed).replace(/\r\n|\r|\n/g, "<br>");
};

export const fileToDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const buildWelcomeLetterHtml = ({
  logoSrc,
  topRightText,
  bodyHtml,
  signatureSrc,
}) => {
  const formattedTopRightText = formatTopRightText(topRightText);
  const hasLogo = Boolean(logoSrc);
  const hasAddress = Boolean(formattedTopRightText);

  let header = "";
  if (hasLogo || hasAddress) {
    const headerColStyle = `flex:1 1 ${WELCOME_LETTER_ADDRESS_COLUMN_WIDTH_PERCENT}%;max-width:${WELCOME_LETTER_ADDRESS_COLUMN_WIDTH_PERCENT}%;min-width:0;box-sizing:border-box;`;
    const addressInnerStyle = "text-align:right;font-size:14px;line-height:1.4;word-wrap:break-word;overflow-wrap:break-word;width:100%;";

    const spacerCol = `<div class="${WELCOME_LETTER_HEADER_COL_CLASS} welcome-letter-header-col-spacer" style="${headerColStyle}"></div>`;

    const logoCol = hasLogo
      ? `<div class="${WELCOME_LETTER_HEADER_COL_CLASS} welcome-letter-header-col-logo" style="${headerColStyle}text-align:center;"><div class="${WELCOME_LETTER_LOGO_CLASS}"><img src="${logoSrc}" alt="hotel-logo" style="width:${WELCOME_LETTER_LOGO_WIDTH}px;height:${WELCOME_LETTER_LOGO_HEIGHT}px;max-width:100%;max-height:${WELCOME_LETTER_LOGO_HEIGHT}px;object-fit:contain;display:inline-block;" /></div></div>`
      : `<div class="${WELCOME_LETTER_HEADER_COL_CLASS} welcome-letter-header-col-logo" style="${headerColStyle}"></div>`;

    const addressCol = hasAddress
      ? `<div class="${WELCOME_LETTER_HEADER_COL_CLASS} welcome-letter-header-col-address" style="${headerColStyle}"><div class="${WELCOME_LETTER_TOP_RIGHT_CLASS}" style="${addressInnerStyle}">${formattedTopRightText}</div></div>`
      : `<div class="${WELCOME_LETTER_HEADER_COL_CLASS} welcome-letter-header-col-address" style="${headerColStyle}"></div>`;

    const headerMinHeight = hasLogo
      ? WELCOME_LETTER_LOGO_HEIGHT
      : WELCOME_LETTER_ADDRESS_HEIGHT;

    header = `<div class="${WELCOME_LETTER_HEADER_CLASS} ${WELCOME_LETTER_HEADER_GRID_CLASS}" style="display:flex;width:100%;align-items:flex-start;margin-bottom:24px;min-height:${headerMinHeight}px;">${spacerCol}${logoCol}${addressCol}</div>`;
  }

  const signature = signatureSrc
    ? `<div class="${WELCOME_LETTER_SIGNATURE_CLASS}" style="margin-top:32px;text-align:left;"><img src="${signatureSrc}" alt="signature" style="width:${WELCOME_LETTER_SIGNATURE_WIDTH}px;height:${WELCOME_LETTER_SIGNATURE_HEIGHT}px;max-width:${WELCOME_LETTER_SIGNATURE_WIDTH}px;max-height:${WELCOME_LETTER_SIGNATURE_HEIGHT}px;object-fit:contain;display:block;" /></div>`
    : "";

  return `<div class="${WELCOME_LETTER_CONTAINER_CLASS}" style="width:100%;text-align:left;">${header}<div class="${WELCOME_LETTER_BODY_CLASS}" style="text-align:left;">${bodyHtml || ""}</div>${signature}</div>`;
};

export const validateWelcomeLetterOptionalImageSize = (file, label = "Image") => {
  const sizeKb = file.size / 1024;
  if (sizeKb > WELCOME_LETTER_OPTIONAL_IMAGE_MAX_KB) {
    return `${label} must be less than ${WELCOME_LETTER_OPTIONAL_IMAGE_MAX_KB} KB`;
  }

  return "";
};

export const resolveWelcomeLetterAssets = async ({
  hotelLogoFile,
  hotelLogoPreviewUrl,
  signatureFile,
  signaturePreviewUrl,
}) => {
  let logoSrc = null;
  if (hotelLogoFile) {
    logoSrc = await fileToDataUrl(hotelLogoFile);
  } else if (hotelLogoPreviewUrl) {
    logoSrc = hotelLogoPreviewUrl;
  }

  let signatureSrc = null;
  if (signatureFile) {
    signatureSrc = await fileToDataUrl(signatureFile);
  } else if (signaturePreviewUrl) {
    signatureSrc = signaturePreviewUrl;
  }

  return { logoSrc, signatureSrc };
};

export const buildWelcomeLetterPreviewContent = async ({
  bodyHtml,
  topRightText,
  hotelLogoFile,
  hotelLogoPreviewUrl,
  signatureFile,
  signaturePreviewUrl,
}) => {
  const { logoSrc, signatureSrc } = await resolveWelcomeLetterAssets({
    hotelLogoFile,
    hotelLogoPreviewUrl,
    signatureFile,
    signaturePreviewUrl,
  });

  return buildWelcomeLetterHtml({
    logoSrc,
    topRightText,
    bodyHtml,
    signatureSrc,
  });
};

export const getWelcomeMediaPresenceFlags = ({
  imageVideoSelection = "",
  imageFile,
  imagePreviewUrl,
  videoFile,
  videoPreviewUrl,
}) => {
  const includesImage = imageVideoSelection === "" || imageVideoSelection === "image";
  const includesVideo = imageVideoSelection === "" || imageVideoSelection === "video";

  return {
    imagePresent: includesImage && Boolean(imageFile || imagePreviewUrl),
    videoPresent: includesVideo && Boolean(videoFile || videoPreviewUrl),
  };
};

export const parseWelcomeLetterHtml = (html = "") => {
  if (!html?.trim()) {
    return {
      logoSrc: null,
      topRightTextPlain: "",
      bodyHtml: "",
      signatureSrc: null,
    };
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const container = doc.querySelector(`.${WELCOME_LETTER_CONTAINER_CLASS}`);

  if (!container) {
    return {
      logoSrc: null,
      topRightTextPlain: "",
      bodyHtml: html,
      signatureSrc: null,
    };
  }

  const logoImg = container.querySelector(`.${WELCOME_LETTER_LOGO_CLASS} img`);
  const topRightEl = container.querySelector(`.${WELCOME_LETTER_TOP_RIGHT_CLASS}`);
  const bodyEl = container.querySelector(`.${WELCOME_LETTER_BODY_CLASS}`);
  const signatureImg = container.querySelector(`.${WELCOME_LETTER_SIGNATURE_CLASS} img`);

  return {
    logoSrc: logoImg?.getAttribute("src") || null,
    topRightTextPlain: parseTopRightTextPlain(topRightEl),
    bodyHtml: bodyEl?.innerHTML?.trim() || "",
    signatureSrc: signatureImg?.getAttribute("src") || null,
  };
};

const normalizeLineEndings = (text = "") => text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");

const truncateAddressToMaxLength = (text = "") => {
  const normalized = normalizeLineEndings(text);
  let contentCount = 0;
  let result = "";

  for (let i = 0; i < normalized.length; i += 1) {
    const char = normalized[i];
    if (char === "\n") {
      result += char;
      continue;
    }
    if (contentCount >= WELCOME_LETTER_ADDRESS_MAX_LENGTH) {
      break;
    }
    result += char;
    contentCount += 1;
  }

  return result;
};

/** Character count for address limits; line breaks are not counted toward the max. */
export const getAddressTextCharacterCount = (text = "") =>
  normalizeLineEndings(text).replace(/\n/g, "").length;

/** Keeps user formatting; truncates content past 100 characters (newlines not counted). */
export const clampAddressText = (text = "") => {
  const withNormalizedEndings = normalizeLineEndings(text);

  if (getAddressTextCharacterCount(withNormalizedEndings) <= WELCOME_LETTER_ADDRESS_MAX_LENGTH) {
    return withNormalizedEndings;
  }

  return truncateAddressToMaxLength(withNormalizedEndings);
};

/**
 * Typing over the limit is rejected; paste is clamped to the first 100 content characters.
 */
export const resolveAddressFieldChange = (nextValue, { isPaste = false } = {}) => {
  const normalized = normalizeLineEndings(nextValue);

  if (getAddressTextCharacterCount(normalized) <= WELCOME_LETTER_ADDRESS_MAX_LENGTH) {
    return { shouldUpdate: true, value: normalized };
  }

  if (isPaste) {
    return { shouldUpdate: true, value: clampAddressText(nextValue) };
  }

  return { shouldUpdate: false };
};

const parseTopRightTextPlain = (element) => {
  if (!element) {
    return "";
  }

  return element.innerHTML
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, "\"")
    .replace(/&#39;/g, "'")
    .trim();
};

export const normalizeAddressText = (text = "") => {
  if (!text?.trim()) {
    return "";
  }

  return clampAddressText(text);
};

export const validateAddressText = (text = "") => {
  if (!text?.trim()) {
    return "";
  }

  if (getAddressTextCharacterCount(text) > WELCOME_LETTER_ADDRESS_MAX_LENGTH) {
    return `Address must not exceed ${WELCOME_LETTER_ADDRESS_MAX_LENGTH} characters`;
  }

  return "";
};

/** Preview: same as stored text; only trims when over 100 content characters. */
export const getAddressTextForPreview = (text = "") => normalizeAddressText(text);

export const prepareAddressTextForSubmit = (text = "") => {
  const normalized = normalizeAddressText(text);
  const error = validateAddressText(normalized);

  return { normalized, error };
};

export const getWelcomeLetterBodyMaxLength = ({
  hasLogo = false,
  hasSignature = false,
} = {}) => {
  if (hasLogo && hasSignature) {
    return WELCOME_LETTER_BODY_MAX_LOGO_AND_SIGNATURE;
  }
  if (hasLogo) {
    return WELCOME_LETTER_BODY_MAX_LOGO_NO_SIGNATURE;
  }
  if (hasSignature) {
    return WELCOME_LETTER_BODY_MAX_NO_LOGO_SIGNATURE;
  }
  return WELCOME_LETTER_BODY_MAX_NO_LOGO_NO_SIGNATURE;
};

export const validateWelcomeLetterTextLength = (
  text = "",
  { hasLogo = false, hasSignature = false } = {}
) => {
  const maxLength = getWelcomeLetterBodyMaxLength({ hasLogo, hasSignature });

  if (text.length > maxLength) {
    return `Welcome text must not exceed ${maxLength} characters`;
  }

  if (text.trim().length > 0 && text.length < WELCOME_LETTER_BODY_MIN_LENGTH) {
    return `Welcome text must be at least ${WELCOME_LETTER_BODY_MIN_LENGTH} characters`;
  }

  return "";
};
